import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@LeadGen/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useMSNCampaignRouterConfig = () => {
  const { t } = useTranslation();

  return [
    {
      path: "/campaign",
      element: LazyLoad("CampaignManagement/Campaign/index"),
      name: t("routes.promotionManagement"),
      key: "Megaphone",
      icon: "Megaphone",
    },
    {
      path: "/campaign/add/plan",
      element: LazyLoad("CampaignManagement/Plan/createPlan"),
      name: t("routes.createPlan"),
      key: "addPlan",
      icon: "",
      isHidden: true,
      fromPath: "/campaign",
    },
    {
      path: "/campaign/add/unit",
      element: LazyLoad("CampaignManagement/Unit/createUnit"),
      name: t("routes.createUnit"),
      key: "unit",
      icon: "",
      isHidden: true,
      fromPath: "/campaign",
    },
    {
      path: "/campaign/add/AdCreative",
      element: LazyLoad("CampaignManagement/Originality/createOriginality"),
      name: t("routes.createCreative"),
      key: "AdCreative",
      icon: "",
      isHidden: true,
      fromPath: "/campaign",
    },
    {
      path: "/campaign/view/AdCreative/:unitCreativeId",
      element: LazyLoad("CampaignManagement/Originality/viewOriginality"),
      name: t("routes.viewCreative"),
      key: "AdCreativePreview",
      icon: "",
      isHidden: true,
      fromPath: "/campaign",
      pathReg: /\/campaign\/view\/AdCreative\/\d+\//,
    },
  ];
};

export const msnCampaignRouterMap: routeConfig[] = [
  {
    path: "/campaign",
    element: LazyLoad("CampaignManagement/Campaign/index"),
    name: "推广管理",
    key: "Megaphone",
    icon: "Megaphone",
  },
  {
    path: "/campaign/add/plan",
    element: LazyLoad("CampaignManagement/Plan/createPlan"),
    name: "新建计划",
    key: "addPlan",
    icon: "",
    isHidden: true,
    fromPath: "/campaign",
  },
  {
    path: "/campaign/add/unit",
    element: LazyLoad("CampaignManagement/Unit/createUnit"),
    name: "新建单元",
    key: "unit",
    icon: "",
    isHidden: true,
    fromPath: "/campaign",
  },
  {
    path: "/campaign/add/AdCreative",
    element: LazyLoad("CampaignManagement/Originality/createOriginality"),
    name: "新建创意",
    key: "AdCreative",
    icon: "",
    isHidden: true,
    fromPath: "/campaign",
  },
  {
    path: "/campaign/view/AdCreative/:unitCreativeId",
    element: LazyLoad("CampaignManagement/Originality/viewOriginality"),
    name: "查看创意",
    key: "AdCreativePreview",
    icon: "",
    isHidden: true,
    fromPath: "/campaign",
    pathReg: /\/campaign\/view\/AdCreative\/\d+\//,
  },
];
